import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const STORAGE_KEY = 'kapital_onboarding_seen';

/* ─────────────────────────────────────────────
   Inline SVG Illustrations  (Storyset / unDraw style)
───────────────────────────────────────────── */

const IllustrationWelcome = () => (
  <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    {/* Sky */}
    <rect width="320" height="200" fill="#F0F9FF" rx="16"/>
    {/* Sun */}
    <circle cx="270" cy="40" r="22" fill="#FDE68A" opacity="0.9"/>
    <circle cx="270" cy="40" r="16" fill="#FCD34D"/>
    {/* Clouds */}
    <ellipse cx="60" cy="35" rx="28" ry="12" fill="white" opacity="0.9"/>
    <ellipse cx="80" cy="30" rx="22" ry="10" fill="white" opacity="0.9"/>
    <ellipse cx="40" cy="32" rx="18" ry="9" fill="white" opacity="0.9"/>
    <ellipse cx="200" cy="25" rx="22" ry="9" fill="white" opacity="0.8"/>
    <ellipse cx="218" cy="21" rx="16" ry="8" fill="white" opacity="0.8"/>
    {/* Ground */}
    <rect x="0" y="155" width="320" height="45" fill="#D1FAE5" rx="0"/>
    <ellipse cx="160" cy="155" rx="160" ry="8" fill="#A7F3D0"/>
    {/* Main building */}
    <rect x="100" y="75" width="120" height="85" fill="#1E3A5F" rx="4"/>
    <rect x="108" y="65" width="104" height="16" fill="#2D5282" rx="3"/>
    {/* Windows building */}
    <rect x="115" y="88" width="20" height="18" fill="#93C5FD" rx="2" opacity="0.9"/>
    <rect x="145" y="88" width="20" height="18" fill="#93C5FD" rx="2" opacity="0.9"/>
    <rect x="175" y="88" width="20" height="18" fill="#93C5FD" rx="2" opacity="0.9"/>
    <rect x="115" y="115" width="20" height="18" fill="#93C5FD" rx="2" opacity="0.9"/>
    <rect x="145" y="115" width="20" height="18" fill="#93C5FD" rx="2" opacity="0.9"/>
    <rect x="175" y="115" width="20" height="18" fill="#93C5FD" rx="2" opacity="0.9"/>
    {/* Door */}
    <rect x="148" y="135" width="24" height="25" fill="#F59E0B" rx="3"/>
    <circle cx="168" cy="148" r="2" fill="#92400E"/>
    {/* Left small house */}
    <rect x="30" y="110" width="55" height="50" fill="#3B82F6" rx="3"/>
    <polygon points="30,110 57,82 85,110" fill="#2563EB"/>
    <rect x="44" y="125" width="14" height="18" fill="#BFDBFE" rx="2"/>
    <rect x="62" y="120" width="14" height="14" fill="#BFDBFE" rx="2"/>
    {/* Right small house */}
    <rect x="235" y="115" width="55" height="45" fill="#10B981" rx="3"/>
    <polygon points="235,115 262,88 290,115" fill="#059669"/>
    <rect x="248" y="128" width="14" height="18" fill="#A7F3D0" rx="2"/>
    <rect x="266" y="123" width="14" height="14" fill="#A7F3D0" rx="2"/>
    {/* Trees */}
    <rect x="20" y="140" width="6" height="18" fill="#92400E"/>
    <ellipse cx="23" cy="135" rx="12" ry="14" fill="#34D399"/>
    <rect x="295" y="138" width="6" height="20" fill="#92400E"/>
    <ellipse cx="298" cy="132" rx="12" ry="14" fill="#34D399"/>
    {/* Gold star badge */}
    <circle cx="160" cy="62" r="10" fill="#F59E0B"/>
    <text x="160" y="66" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold">★</text>
    {/* Path */}
    <path d="M148 160 Q160 158 172 160 L175 200 H145 Z" fill="#FDE68A" opacity="0.7"/>
  </svg>
);

const IllustrationCommune = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="320" height="180" fill="#ECFDF5" rx="12"/>
    {/* Map background */}
    <rect x="20" y="20" width="280" height="140" fill="#D1FAE5" rx="10"/>
    {/* Map roads */}
    <line x1="20" y1="90" x2="300" y2="90" stroke="#A7F3D0" strokeWidth="8"/>
    <line x1="160" y1="20" x2="160" y2="160" stroke="#A7F3D0" strokeWidth="8"/>
    <line x1="20" y1="130" x2="120" y2="90" stroke="#A7F3D0" strokeWidth="5" strokeDasharray="6 3"/>
    <line x1="200" y1="90" x2="300" y2="50" stroke="#A7F3D0" strokeWidth="5" strokeDasharray="6 3"/>
    {/* Zones */}
    <rect x="35" y="35" width="110" height="45" fill="#6EE7B7" rx="8" opacity="0.5"/>
    <rect x="175" y="35" width="110" height="45" fill="#34D399" rx="8" opacity="0.4"/>
    <rect x="35" y="100" width="110" height="45" fill="#10B981" rx="8" opacity="0.3"/>
    <rect x="175" y="100" width="110" height="45" fill="#6EE7B7" rx="8" opacity="0.5"/>
    {/* Pin markers */}
    <ellipse cx="90" cy="62" rx="6" ry="3" fill="#065F46" opacity="0.3"/>
    <path d="M90 30 C80 30 72 38 72 48 C72 62 90 72 90 72 C90 72 108 62 108 48 C108 38 100 30 90 30Z" fill="#059669"/>
    <circle cx="90" cy="48" r="6" fill="white"/>
    <ellipse cx="230" cy="62" rx="6" ry="3" fill="#065F46" opacity="0.3"/>
    <path d="M230 30 C220 30 212 38 212 48 C212 62 230 72 230 72 C230 72 248 62 248 48 C248 38 240 30 230 30Z" fill="#10B981"/>
    <circle cx="230" cy="48" r="6" fill="white"/>
    {/* Highlighted pin */}
    <ellipse cx="160" cy="125" rx="8" ry="4" fill="#065F46" opacity="0.4"/>
    <path d="M160 88 C146 88 135 99 135 113 C135 131 160 148 160 148 C160 148 185 131 185 113 C185 99 174 88 160 88Z" fill="#F59E0B"/>
    <circle cx="160" cy="113" r="9" fill="white"/>
    <circle cx="160" cy="113" r="5" fill="#F59E0B"/>
    {/* Compass */}
    <circle cx="280" cy="155" r="14" fill="white" opacity="0.9"/>
    <text x="280" y="159" textAnchor="middle" fontSize="11" fill="#059669" fontWeight="bold">N</text>
    <line x1="280" y1="145" x2="280" y2="141" stroke="#059669" strokeWidth="2"/>
  </svg>
);

const IllustrationVideo = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="320" height="180" fill="#F5F3FF" rx="12"/>
    {/* TV / Screen frame */}
    <rect x="30" y="25" width="200" height="130" fill="#1E1B4B" rx="12"/>
    <rect x="38" y="33" width="184" height="114" fill="#312E81" rx="8"/>
    {/* Screen content - property image */}
    <rect x="38" y="33" width="184" height="114" fill="#4338CA" rx="8"/>
    <rect x="38" y="33" width="184" height="60" fill="#3730A3" rx="8"/>
    {/* Building silhouette on screen */}
    <rect x="70" y="70" width="50" height="55" fill="#6366F1" rx="3"/>
    <rect x="130" y="55" width="70" height="70" fill="#818CF8" rx="3"/>
    <rect x="80" y="60" width="12" height="12" fill="#C7D2FE" rx="1" opacity="0.8"/>
    <rect x="98" y="60" width="12" height="12" fill="#C7D2FE" rx="1" opacity="0.8"/>
    <rect x="140" y="65" width="14" height="14" fill="#C7D2FE" rx="1" opacity="0.8"/>
    <rect x="162" y="65" width="14" height="14" fill="#C7D2FE" rx="1" opacity="0.8"/>
    <rect x="140" y="88" width="14" height="14" fill="#C7D2FE" rx="1" opacity="0.8"/>
    <rect x="162" y="88" width="14" height="14" fill="#C7D2FE" rx="1" opacity="0.8"/>
    {/* Play button overlay */}
    <circle cx="130" cy="90" r="22" fill="white" opacity="0.15"/>
    <circle cx="130" cy="90" r="16" fill="white" opacity="0.9"/>
    <polygon points="125,83 125,97 140,90" fill="#7C3AED"/>
    {/* Progress bar */}
    <rect x="38" y="138" width="184" height="5" fill="#1E1B4B" rx="2"/>
    <rect x="38" y="138" width="90" height="5" fill="#A78BFA" rx="2"/>
    <circle cx="128" cy="140" r="4" fill="#7C3AED"/>
    {/* TV stand */}
    <rect x="115" y="155" width="30" height="8" fill="#1E1B4B" rx="2"/>
    <rect x="100" y="163" width="60" height="6" fill="#312E81" rx="3"/>
    {/* Side thumbnails */}
    <rect x="245" y="30" width="60" height="40" fill="#7C3AED" rx="6" opacity="0.8"/>
    <polygon points="268,46 268,58 278,52" fill="white" opacity="0.9"/>
    <rect x="245" y="78" width="60" height="40" fill="#8B5CF6" rx="6" opacity="0.7"/>
    <polygon points="268,94 268,106 278,100" fill="white" opacity="0.9"/>
    <rect x="245" y="126" width="60" height="40" fill="#6D28D9" rx="6" opacity="0.6"/>
    <polygon points="268,142 268,154 278,148" fill="white" opacity="0.9"/>
    {/* Stars rating */}
    <text x="245" y="175" fontSize="12" fill="#F59E0B">★★★★★</text>
  </svg>
);

const IllustrationWishlist = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="320" height="180" fill="#FFF1F2" rx="12"/>
    {/* Phone frame */}
    <rect x="110" y="15" width="100" height="155" fill="#1F2937" rx="16"/>
    <rect x="116" y="22" width="88" height="141" fill="#F9FAFB" rx="10"/>
    {/* Notch */}
    <rect x="145" y="15" width="30" height="8" fill="#374151" rx="4"/>
    {/* App header */}
    <rect x="116" y="22" width="88" height="22" fill="#FFF1F2" rx="10"/>
    <text x="160" y="37" textAnchor="middle" fontSize="8" fill="#BE123C" fontWeight="bold">Ma Wishlist</text>
    {/* Property cards */}
    <rect x="122" y="50" width="76" height="38" fill="white" rx="6" filter="url(#shadow1)"/>
    <rect x="122" y="50" width="76" height="18" fill="#FECDD3" rx="6"/>
    <rect x="122" y="62" width="76" height="6" fill="#FECDD3"/>
    <text x="134" y="78" fontSize="6" fill="#374151">Cocody • 85m²</text>
    <text x="134" y="85" fontSize="6" fill="#BE123C" fontWeight="bold">45M FCFA</text>
    {/* Heart filled */}
    <path d="M188 54 C188 52 186 50 184 50 C182 50 180 52 180 54 C180 56 184 60 184 60 C184 60 188 56 188 54Z" fill="#F43F5E"/>

    <rect x="122" y="95" width="76" height="38" fill="white" rx="6"/>
    <rect x="122" y="95" width="76" height="18" fill="#FCE7F3" rx="6"/>
    <rect x="122" y="107" width="76" height="6" fill="#FCE7F3"/>
    <text x="134" y="123" fontSize="6" fill="#374151">Marcory • 120m²</text>
    <text x="134" y="130" fontSize="6" fill="#BE123C" fontWeight="bold">78M FCFA</text>
    <path d="M188 99 C188 97 186 95 184 95 C182 95 180 97 180 99 C180 101 184 105 184 105 C184 105 188 101 188 99Z" fill="#F43F5E"/>

    <rect x="122" y="140" width="76" height="18" fill="white" rx="6"/>
    <text x="160" y="152" textAnchor="middle" fontSize="6" fill="#9CA3AF">+ 3 autres biens</text>

    {/* Floating hearts */}
    <path d="M60 60 C60 55 54 50 48 50 C42 50 36 55 36 60 C36 70 48 80 48 80 C48 80 60 70 60 60Z" fill="#FB7185" opacity="0.9"/>
    <path d="M82 35 C82 31 77 27 72 27 C67 27 62 31 62 35 C62 42 72 50 72 50 C72 50 82 42 82 35Z" fill="#F43F5E" opacity="0.7"/>
    <path d="M40 100 C40 97 37 94 34 94 C31 94 28 97 28 100 C28 104 34 109 34 109 C34 109 40 104 40 100Z" fill="#FDA4AF" opacity="0.8"/>
    {/* Bell notification */}
    <circle cx="270" cy="55" r="28" fill="#FFF1F2" opacity="0.9"/>
    <path d="M270 35 C262 35 256 41 256 50 L256 58 L250 64 L290 64 L284 58 L284 50 C284 41 278 35 270 35Z" fill="#F43F5E" opacity="0.8"/>
    <rect x="265" y="64" width="10" height="5" fill="#F43F5E" rx="2" opacity="0.8"/>
    <circle cx="282" cy="40" r="7" fill="#10B981"/>
    <text x="282" y="44" textAnchor="middle" fontSize="8" fill="white" fontWeight="bold">3</text>
    {/* Price tag */}
    <rect x="240" y="100" width="60" height="28" fill="#FFF1F2" rx="8" opacity="0.95"/>
    <text x="270" y="112" textAnchor="middle" fontSize="7" fill="#9CA3AF">Prix réduit</text>
    <text x="270" y="123" textAnchor="middle" fontSize="8" fill="#BE123C" fontWeight="bold">-12% ↓</text>
  </svg>
);

const IllustrationNotary = () => (
  <svg viewBox="0 0 320 180" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
    <rect width="320" height="180" fill="#FFFBEB" rx="12"/>
    {/* Desk */}
    <rect x="20" y="130" width="280" height="12" fill="#92400E" rx="4"/>
    <rect x="30" y="142" width="12" height="30" fill="#78350F" rx="2"/>
    <rect x="278" y="142" width="12" height="30" fill="#78350F" rx="2"/>
    {/* Document stack */}
    <rect x="50" y="90" width="80" height="42" fill="#FEF3C7" rx="4" transform="rotate(-3 50 90)"/>
    <rect x="52" y="88" width="80" height="42" fill="#FDE68A" rx="4" transform="rotate(-1 52 88)"/>
    <rect x="54" y="86" width="80" height="42" fill="white" rx="4"/>
    {/* Document lines */}
    <line x1="64" y1="98" x2="124" y2="98" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round"/>
    <line x1="64" y1="106" x2="124" y2="106" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round"/>
    <line x1="64" y1="114" x2="104" y2="114" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round"/>
    {/* Signature line */}
    <line x1="64" y1="122" x2="124" y2="122" stroke="#F59E0B" strokeWidth="1.5" strokeDasharray="4 2"/>
    <path d="M68 122 Q75 116 80 122 Q85 128 92 122" stroke="#1E3A5F" strokeWidth="2" fill="none" strokeLinecap="round"/>
    {/* Seal / stamp */}
    <circle cx="118" cy="118" r="10" fill="#F59E0B" opacity="0.9"/>
    <circle cx="118" cy="118" r="7" fill="none" stroke="#92400E" strokeWidth="1.5" strokeDasharray="2 1"/>
    <text x="118" y="122" textAnchor="middle" fontSize="7" fill="#92400E" fontWeight="bold">✓</text>
    {/* Notary person */}
    <circle cx="220" cy="65" r="22" fill="#FDE68A"/>
    <circle cx="220" cy="58" r="14" fill="#FBBF24"/>
    {/* Suit */}
    <path d="M196 130 C196 108 204 100 220 100 C236 100 244 108 244 130" fill="#1E3A5F"/>
    <path d="M212 100 L220 115 L228 100" fill="white"/>
    <rect x="218" y="100" width="4" height="20" fill="#F59E0B"/>
    {/* Tie */}
    <polygon points="220,102 217,110 220,120 223,110" fill="#F59E0B"/>
    {/* Arms */}
    <path d="M196 110 Q180 118 178 130" stroke="#1E3A5F" strokeWidth="10" strokeLinecap="round" fill="none"/>
    <path d="M244 110 Q260 118 262 130" stroke="#1E3A5F" strokeWidth="10" strokeLinecap="round" fill="none"/>
    {/* Hands */}
    <circle cx="178" cy="132" r="7" fill="#FBBF24"/>
    <circle cx="262" cy="132" r="7" fill="#FBBF24"/>
    {/* Pen in hand */}
    <rect x="258" y="118" width="3" height="20" fill="#374151" rx="1" transform="rotate(20 258 118)"/>
    <polygon points="258,138 261,138 259.5,144" fill="#F59E0B" transform="rotate(20 258 118)"/>
    {/* Calendar */}
    <rect x="185" y="30" width="50" height="45" fill="white" rx="6" opacity="0.95"/>
    <rect x="185" y="30" width="50" height="14" fill="#F59E0B" rx="6"/>
    <rect x="185" y="38" width="50" height="6" fill="#F59E0B"/>
    <text x="210" y="42" textAnchor="middle" fontSize="7" fill="white" fontWeight="bold">JUIN</text>
    <text x="197" y="55" textAnchor="middle" fontSize="7" fill="#6B7280">L M M</text>
    <text x="223" y="55" textAnchor="middle" fontSize="7" fill="#6B7280">J V S</text>
    <circle cx="210" cy="64" r="6" fill="#F59E0B"/>
    <text x="210" y="67" textAnchor="middle" fontSize="7" fill="white" fontWeight="bold">15</text>
    {/* Checkmark badge */}
    <circle cx="280" cy="40" r="18" fill="#10B981"/>
    <path d="M272 40 L278 46 L290 34" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

/* ─────────────────────────────────────────────
   Feature data
───────────────────────────────────────────── */
const features = [
  {
    id: 'commune',
    icon: 'MapPin',
    color: 'from-emerald-500 to-teal-600',
    bgLight: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    textColor: 'text-emerald-700',
    title: 'Explorateur de Communes',
    description:
      'Découvrez chaque quartier en profondeur : infrastructures, style de vie, tendances du marché et avis de résidents pour faire le meilleur choix.',
    cta: 'Explorer les communes',
    path: '/commune-explorer',
    badge: 'Découverte',
    Illustration: IllustrationCommune,
  },
  {
    id: 'video',
    icon: 'PlayCircle',
    color: 'from-violet-500 to-purple-700',
    bgLight: 'bg-violet-50',
    borderColor: 'border-violet-200',
    textColor: 'text-violet-700',
    title: 'Visites Vidéo Immersives',
    description:
      'Visitez des propriétés depuis chez vous grâce à nos vidéos haute définition. Filtrez par commune, prix et type de bien.',
    cta: 'Voir les vidéos',
    path: '/video-tour-discovery-center',
    badge: 'Nouveau',
    Illustration: IllustrationVideo,
  },
  {
    id: 'wishlist',
    icon: 'Heart',
    color: 'from-rose-500 to-pink-600',
    bgLight: 'bg-rose-50',
    borderColor: 'border-rose-200',
    textColor: 'text-rose-700',
    title: 'Ma Wishlist',
    description:
      'Sauvegardez vos propriétés favorites, comparez-les et recevez des alertes dès qu\'un bien de votre liste change de prix.',
    cta: 'Voir mes favoris',
    path: '/property-search-listings',
    badge: 'Personnalisé',
    Illustration: IllustrationWishlist,
  },
  {
    id: 'notary',
    icon: 'Scale',
    color: 'from-amber-500 to-orange-600',
    bgLight: 'bg-amber-50',
    borderColor: 'border-amber-200',
    textColor: 'text-amber-700',
    title: 'Réservation Notaire',
    description:
      'Prenez rendez-vous avec des notaires certifiés en quelques clics. Accompagnement juridique complet pour vos transactions.',
    cta: 'Réserver un notaire',
    path: '/notary-appointment-booking-system',
    badge: 'Juridique',
    Illustration: IllustrationNotary,
  },
];

/* ─────────────────────────────────────────────
   Main component
───────────────────────────────────────────── */
const WelcomeOnboarding = ({ onDismiss }) => {
  const [step, setStep] = useState(0); // 0 = welcome screen, 1-4 = feature tooltips
  const [animating, setAnimating] = useState(false);
  const navigate = useNavigate();

  const totalSteps = features?.length;
  const isWelcome = step === 0;
  const currentFeature = features?.[step - 1];

  const goNext = () => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setStep((s) => s + 1);
      setAnimating(false);
    }, 220);
  };

  const goPrev = () => {
    if (animating || step === 0) return;
    setAnimating(true);
    setTimeout(() => {
      setStep((s) => s - 1);
      setAnimating(false);
    }, 220);
  };

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    onDismiss?.();
  };

  const handleCTA = (path) => {
    localStorage.setItem(STORAGE_KEY, 'true');
    onDismiss?.();
    navigate(path);
  };

  const handleSkip = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    onDismiss?.();
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={handleDismiss}
        aria-hidden="true"
      />
      {/* Modal */}
      <div
        className={`relative w-full max-w-lg bg-white rounded-3xl shadow-2xl overflow-hidden transition-all duration-300 ${
          animating ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
        }`}
        style={{ maxHeight: '92vh', overflowY: 'auto' }}
      >
        {/* Progress bar */}
        {!isWelcome && (
          <div className="absolute top-0 left-0 right-0 h-1 bg-gray-100 z-10">
            <div
              className="h-full bg-gradient-to-r from-brand-gold to-brand-earth transition-all duration-500 ease-out"
              style={{ width: `${(step / totalSteps) * 100}%` }}
            />
          </div>
        )}

        {/* Close button */}
        <button
          onClick={handleDismiss}
          className="absolute top-4 right-4 z-20 w-8 h-8 flex items-center justify-center rounded-full bg-white/80 backdrop-blur-sm hover:bg-gray-100 transition-colors shadow-sm"
          aria-label="Fermer"
        >
          <Icon name="X" size={16} color="#6B7280" strokeWidth={2.5} />
        </button>

        {/* ── WELCOME SCREEN ── */}
        {isWelcome && (
          <div className="flex flex-col">
            {/* Illustration hero */}
            <div className="w-full h-44 bg-gradient-to-br from-sky-50 to-emerald-50 overflow-hidden">
              <IllustrationWelcome />
            </div>

            <div className="p-7 pt-5">
              <div className="text-center mb-6">
                <div className="flex justify-center mb-3">
                  <div className="relative">
                    <div className="w-14 h-14 bg-gradient-to-br from-brand-gold to-brand-earth rounded-2xl flex items-center justify-center shadow-lg">
                      <Icon name="Building2" size={28} color="white" strokeWidth={2} />
                    </div>
                    <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-emerald-500 rounded-full flex items-center justify-center border-2 border-white">
                      <Icon name="Sparkles" size={11} color="white" strokeWidth={2.5} />
                    </div>
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2 leading-tight">
                  Bienvenue sur{' '}
                  <span className="text-brand-earth">Kapital States</span>
                </h2>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Votre plateforme immobilière premium en Côte d'Ivoire. Découvrez tout ce que vous pouvez faire en quelques étapes.
                </p>
              </div>

              {/* Feature preview pills */}
              <div className="grid grid-cols-2 gap-3 mb-7">
                {features?.map((f) => (
                  <div
                    key={f?.id}
                    className={`flex items-center gap-2.5 px-3 py-2.5 rounded-xl border ${f?.borderColor} ${f?.bgLight}`}
                  >
                    <div className={`w-7 h-7 rounded-lg bg-gradient-to-br ${f?.color} flex items-center justify-center flex-shrink-0`}>
                      <Icon name={f?.icon} size={14} color="white" strokeWidth={2.5} />
                    </div>
                    <span className={`text-xs font-semibold ${f?.textColor} leading-tight`}>
                      {f?.title}
                    </span>
                  </div>
                ))}
              </div>

              <div className="space-y-3">
                <button
                  onClick={goNext}
                  className="w-full py-3.5 bg-gradient-to-r from-brand-earth to-brand-gold text-white font-semibold rounded-2xl hover:opacity-90 transition-opacity flex items-center justify-center gap-2 shadow-md"
                >
                  Découvrir les fonctionnalités
                  <Icon name="ArrowRight" size={18} color="white" strokeWidth={2.5} />
                </button>
                <button
                  onClick={handleSkip}
                  className="w-full py-2.5 text-gray-400 text-sm hover:text-gray-600 transition-colors"
                >
                  Passer l'introduction
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── FEATURE TOOLTIP SCREENS ── */}
        {!isWelcome && currentFeature && (() => {
          const Illus = currentFeature?.Illustration;
          return (
            <div className="flex flex-col">
              {/* Illustration hero area */}
              <div className={`relative overflow-hidden`} style={{ background: 'transparent' }}>
                {/* Gradient tint overlay behind illustration */}
                <div className={`absolute inset-0 bg-gradient-to-br ${currentFeature?.color} opacity-10`} />
                <div className="w-full h-44">
                  {Illus && <Illus />}
                </div>
                {/* Step + badge chips */}
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className={`px-2.5 py-1 text-xs font-semibold rounded-full backdrop-blur-sm bg-white/80 shadow-sm ${currentFeature?.textColor}`}>
                    {step} / {totalSteps}
                  </span>
                  <span className={`px-2.5 py-1 text-xs font-semibold rounded-full backdrop-blur-sm bg-white/80 shadow-sm ${currentFeature?.textColor}`}>
                    {currentFeature?.badge}
                  </span>
                </div>
              </div>

              {/* Feature content */}
              <div className="p-6 pt-5">
                {/* Title row */}
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 bg-gradient-to-br ${currentFeature?.color} rounded-xl flex items-center justify-center flex-shrink-0 shadow-md`}>
                    <Icon name={currentFeature?.icon} size={20} color="white" strokeWidth={2} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 leading-tight">
                    {currentFeature?.title}
                  </h3>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed mb-5">
                  {currentFeature?.description}
                </p>

                {/* Tooltip hint */}
                <div className={`flex items-start gap-3 p-3 rounded-xl border ${currentFeature?.borderColor} ${currentFeature?.bgLight} mb-5`}>
                  <div className={`w-6 h-6 rounded-full bg-gradient-to-br ${currentFeature?.color} flex items-center justify-center flex-shrink-0 mt-0.5`}>
                    <Icon name="Lightbulb" size={12} color="white" strokeWidth={2.5} />
                  </div>
                  <p className={`text-xs ${currentFeature?.textColor} leading-relaxed font-medium`}>
                    {step === 1 && 'Astuce : Utilisez les filtres de commune pour affiner votre recherche par quartier.'}
                    {step === 2 && "Astuce : Ajoutez des vidéos à votre file d'attente pour les regarder plus tard."}
                    {step === 3 && 'Astuce : Activez les alertes prix pour être notifié dès qu\'un bien change de tarif.'}
                    {step === 4 && 'Astuce : Préparez vos documents à l\'avance pour accélérer votre rendez-vous.'}
                  </p>
                </div>

                {/* Navigation */}
                <div className="flex items-center gap-3">
                  {step > 1 && (
                    <button
                      onClick={goPrev}
                      className="w-11 h-11 flex items-center justify-center rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors flex-shrink-0"
                    >
                      <Icon name="ChevronLeft" size={20} color="#6B7280" strokeWidth={2.5} />
                    </button>
                  )}

                  <button
                    onClick={() => handleCTA(currentFeature?.path)}
                    className={`flex-1 py-3 bg-gradient-to-r ${currentFeature?.color} text-white font-semibold rounded-xl hover:opacity-90 transition-opacity flex items-center justify-center gap-2 text-sm shadow-md`}
                  >
                    {currentFeature?.cta}
                    <Icon name="ArrowRight" size={16} color="white" strokeWidth={2.5} />
                  </button>

                  {step < totalSteps ? (
                    <button
                      onClick={goNext}
                      className="w-11 h-11 flex items-center justify-center rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors flex-shrink-0"
                    >
                      <Icon name="ChevronRight" size={20} color="#6B7280" strokeWidth={2.5} />
                    </button>
                  ) : (
                    <button
                      onClick={handleDismiss}
                      className="w-11 h-11 flex items-center justify-center rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors flex-shrink-0"
                      title="Terminer"
                    >
                      <Icon name="Check" size={20} color="#6B7280" strokeWidth={2.5} />
                    </button>
                  )}
                </div>

                {/* Dot indicators */}
                <div className="flex items-center justify-center gap-1.5 mt-5">
                  {features?.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => {
                        if (!animating) {
                          setAnimating(true);
                          setTimeout(() => { setStep(i + 1); setAnimating(false); }, 220);
                        }
                      }}
                      className={`rounded-full transition-all duration-300 ${
                        i + 1 === step
                          ? 'w-5 h-2 bg-brand-earth' :'w-2 h-2 bg-gray-200 hover:bg-gray-300'
                      }`}
                      aria-label={`Aller à l'étape ${i + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export { STORAGE_KEY };
export default WelcomeOnboarding;
